import apiClient from '../helper/apiClient';
import MOCK_IMAGES_LIST_DATA from '../mock/imagelist-media.json';
import MOCK_UPLOAD_RESPONSE from '../mock/images-upload-response.json';
import { SERVICE_ROUTES } from '../constants/service.constants';

export const getImagesListData = async (zoomMeetingUuid, region) => {
  if (process.env.NODE_ENV !== 'development') {
    zoomMeetingUuid = encodeURIComponent(zoomMeetingUuid);
    const httpClient = apiClient.getZoomAppBffInstance();
    const endPoint = SERVICE_ROUTES.FETCH_IMAGES_LIST.replace('{zoomMeetingUuid}', zoomMeetingUuid).replace('{region}', region);
    return httpClient.get(endPoint);
  }
  return MOCK_IMAGES_LIST_DATA;
};

export const uploadImages = async formData => {
  if (process.env.NODE_ENV !== 'development') {
    const httpClient = apiClient.getZoomAppBffInstance();
    return httpClient.post(SERVICE_ROUTES.UPLOAD_IMAGE, formData);
  }
  return MOCK_UPLOAD_RESPONSE;
};
